import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Select,
  Modal,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { FileIcon } from "@shopify/polaris-icons";
import { EDITOR_CONFIG } from "../../constants";
import JoditEditor from "jodit-react";

const AddEditRoom = (props) => {
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const imageKey = useRef("");
  const videoKey = useRef("");
  const editor = useRef(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    title: "",
    description: "",
    isActive: true,
    is_private: false,
  });
  const handleChangePrivate = (newValue) => {
    setItem({ ...item, is_private: newValue });
  };
  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };
  const handleChangeTitle = (newValue) => {
    setItem({ ...item, title: newValue });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");

  const handleChangeGender = (newValue) => {
    setItem({ ...item, gender: newValue });
    setGenderError("");
  };
  const [genderError, setGenderError] = useState("");
  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);
  const handleDropZone = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const fileUpload = !files.length && (
    <DropZone.FileUpload actionHint={"Accepts jpegs and pngs"} />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendImage = (files) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "package");
    form_data.append("image", files[files.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(files[files.length - 1].type) > 0
              ? window.URL.createObjectURL(files[files.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [filesVideo, setFilesVideo] = useState([]);
  const handleDropZoneVideo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesVideo((filesVideo) => [...filesVideo, ...acceptedFiles]),
    []
  );
  const fileUploadVideo = !filesVideo.length && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFilesVideo = filesVideo.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(filesVideo[filesVideo.length - 1].type)
              ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
              : NoteIcon
          }
        />
        <div>
          {filesVideo[filesVideo.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {filesVideo[filesVideo.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendVideo = (filesVideo) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "intro_content");
    form_data.append("video", filesVideo[filesVideo.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        videoKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          video:
            validImageTypes.indexOf(filesVideo[filesVideo.length - 1].type) > 0
              ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [filesImage, setFilesImage] = useState([]);
  const handleDropZoneImage = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesImage((filesImage) => [...filesImage, ...acceptedFiles]),
    []
  );
  const fileUploadImage = !filesImage.length && (
    <DropZone.FileUpload
      actionHint={"Accepts jpegs and pngs (Required size: 1440x720 pixels)"}
    />
  );
  const uploadedFilesImage = filesImage.length > 0 && (
    <div style={{ padding: "0" }}>
      {filesImage.map((file, index) => (
        <div key={index} className="rowDiv">
          <Thumbnail
            size="small"
            alt={file.title}
            source={
              validImageTypes.includes(file.type)
                ? window.URL.createObjectURL(file)
                : NoteIcon
            }
          />
          <div>
            {file.title}{" "}
            <Text variant="bodySm" as="p">
              {file.size} bytes
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
  const sendImageImage = (filesImage) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "intro_content");
    form_data.append("image", filesImage[filesImage.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(filesImage[filesImage.length - 1].type) > 0
              ? window.URL.createObjectURL(filesImage[filesImage.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/rooms/${id}`)
        .then((result) => {
          console.log(result.data.data);
          setItem({
            title: result?.data?.data?.title ? result.data.data.title : "",
            isActive: result?.data?.data?.is_active ? true : false,
            is_private: result?.data?.data?.is_private ? true : false,
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/rooms/${id}`)
      .then((result) => {
        navigate("/admin/rooms");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Room`}
      backAction={{ onAction: () => navigate("/admin/rooms") }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <TextField
            value={item.title}
            onChange={handleChangeTitle}
            label="Name"
            error={titleError}
          />
          {/* <TextField
            value={item.description}
            onChange={handleChangeDescription}
            label="Description"
          />
          <Text>Image</Text>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".jpeg,.jpg,.png"
                onDrop={handleDropZoneImage}
                allowMultiple={false}
                onDropAccepted={sendImageImage}
              >
                {uploadedFilesImage}
                {fileUploadImage}
              </DropZone>
            </div>
          </div>
          <Checkbox
            label="Private"
            checked={item.is_private}
            onChange={handleChangePrivate}
          /> */}
          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              Delete
            </Button>
          )
        }
      />
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!item.title) {
      !item.title && setTitleError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("title", item.title);
      form_data.append("is_active", item.isActive ? 1 : 0);
      form_data.append("is_private", item.is_private ? 1 : 0);
      props.type === "edit" && form_data.append("_method", "PATCH");

      props.type === "add"
        ? axios
            .post(`/rooms`, form_data)
            .then((result) => {
              navigate("/admin/rooms");
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/rooms/${id}`, form_data)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditRoom;
